/* eslint-disable no-nested-ternary */
import HUBSPOT from '../constants/hubspot';

const {
  HUBSPOT_CLIENT_ID,
  HUBSPOT_APP_INSTALL_PATH,
  HUBSPOT_REDIRECT_URI_DEV,
  HUBSPOT_REDIRECT_URI_STG,
  HUBSPOT_REDIRECT_URI_PRD,
  HUBSPOT_PERMISSION_SCOPE
} = HUBSPOT;

const RESTRICTED_SUBDOMAINS = ['app', 'id'];

export default (() => {
  const { host } = window.location;
  const orgSubDomain = host.split('.')[1] ?
  host.split('.')[0] :
  false;

  if (
  !orgSubDomain ||
  RESTRICTED_SUBDOMAINS.includes(orgSubDomain) // block install if no workspace in url
  ) return;

  const HUBSPOT_REDIRECT_URI = host.includes('app.shootsta') ?
  HUBSPOT_REDIRECT_URI_PRD :
  host.includes('staging.shootsta') ?
  HUBSPOT_REDIRECT_URI_STG :
  HUBSPOT_REDIRECT_URI_DEV;

  const authUrl = `${HUBSPOT_APP_INSTALL_PATH
  }?client_id=${HUBSPOT_CLIENT_ID}` +
  `&scope=${HUBSPOT_PERMISSION_SCOPE}` +
  `&redirect_uri=${`https://${HUBSPOT_REDIRECT_URI}`}`;

  // Redirect user to initiate Shootsta's HubSpot app OAuth flow in new window
  window.open(authUrl, '_blank');

  // Redirect active window to app.shootsta.com?hubspot=myworkspace
  // in order to store the users workspace in localstorage so we know
  // which workspace the HubSpot app has been installed to when HubSpot
  // redirects the user to app.shootsta.com after successful OAuth
  window.open(`https://${HUBSPOT_REDIRECT_URI}?hubspot=${orgSubDomain}`, '_self');
});